import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

interface AppButtonProps extends ButtonProps {
  loading?: boolean;
  appVariant?: "primary" | "secondary";
}

export default function AppButton({
  children,
  loading = false,
  disabled,
  appVariant = "primary",
  sx,
  ...props
}: AppButtonProps) {
  const isPrimary = appVariant === "primary";

  return (
    <Button
      {...props}
      variant="contained"
      disableElevation
      disabled={disabled || loading}
      sx={{
        height: "46px",
        borderRadius: "8px",
        paddingInline: "20px",

        textTransform: "none",

        fontFamily: `"Poppins", sans-serif`,
        fontSize: "14px",
        fontWeight: 500,
        letterSpacing: "0.01em",

        // ── Variant-based styles ──
        background: isPrimary ? "var(--gold-grad)" : "rgb(var(--surface-2))",
        color: isPrimary ? "#fff" : "rgb(var(--text-primary))",
        border: isPrimary ? "none" : "1px solid rgb(var(--border-secondary))",

        transition: "all 0.25s ease",

        "&:hover": isPrimary
          ? {
              backgroundColor: "rgb(var(--color-gold-1))",
              boxShadow: "0 10px 30px rgba(184,137,58,0.25)",
              transform: "scale(1.01)",
            }
          : {
              backgroundColor: "rgb(var(--surface-3))",
              transform: "scale(1.01)",
            },

        "&:active": {
          transform: "scale(0.98)",
        },

        "&.Mui-disabled": {
          opacity: "0.5",
        },

        "&.MuiButtonBase-root": {
          color: isPrimary ? "rgb(var(--background))" : "rgb(var(--text-primary))",
        },

        ...sx,
      }}
    >
      {loading ? (
        <div className="flex items-center gap-2">
          <CircularProgress
            size={16}
            thickness={5}
            sx={{ color: isPrimary ? "#fff" : "rgb(var(--text-primary))" }}
          />
          <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "14px", fontWeight: 500 }}>
            {isPrimary ? "Signing In..." : "Loading..."}
          </span>
        </div>
      ) : (
        children
      )}
    </Button>
  );
}